import React, { createContext, useContext } from 'react';

// Definiamo una "forma" più completa per i nostri dati di default.
// Questo aiuta anche con l'autocompletamento nel tuo editor di codice.
const defaultContextValue = {
    // Funzioni
    openChatForOrder: () => { console.warn('AppContext: openChatForOrder non è stato ancora fornito.'); },
    openProductsDialog: () => { console.warn('AppContext: openProductsDialog non è stato ancora fornito.'); },

    // Dati
    glsShipments: [],     // Valore di default: un array vuoto
    currentUser: null,    // Valore di default: null
    isInitialized: false, // Valore di default: false
};

const AppContext = createContext(defaultContextValue);

export const AppProvider = AppContext.Provider;

export const useAppContext = () => useContext(AppContext);